import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { interval, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-create-update-send-e-cartes',
  templateUrl: './create-update-send-e-cartes.component.html',
  styleUrls: ['./create-update-send-e-cartes.component.css']
})
export class CreateUpdateSendECartesComponent implements OnInit {

  // adminName:string="";
  // listeAdmin:any[]=[{
  //   nom:"YAO",
  //   prenom:"Kouassi",
  //   login:"yakou",
  //   contact:"09212109",
  //   statut:'COMMERCANT',
  //   createdAt:"10/10/2010"
  // }];
  // p:number=1
  @Input() sendECarteToUpdate;
  spinnerLoading:boolean=false;
  periodOver = false;
  onClose: Subject<any> = new Subject<any>();
  
  createUpdateSendECartesForm : FormGroup;
  clientFormGroup : FormGroup;
  firstStep = true;

  connectedUser: any;
  clients: any[] = [];

  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  otp: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '-',
    inputStyles: {},
    inputClass: 'otp-input'
  };
  EnvoiID : number = 0;
  addCustomer = false;
  ng2TelInputOptions: Object;
  dialCode: string;
  submitted = false;
  constructor(public httpService:HttpService,private notification:NotificationService,public modalRef:BsModalRef,private formBuilder:FormBuilder) { 
    this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
    this.ng2TelInputOptions = {
      initialCountry: this.connectedUser["CodePays"] ? this.connectedUser["CodePays"].toLowerCase() : 'ci'
    }
  }

  ngOnInit() {
    //console.log("commande to update", this.commandeToUpdate);
    

    //this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';

    this.createUpdateSendECartesForm = this.formBuilder.group({
      MontantEcarte: [this.sendECarteToUpdate ? this.sendECarteToUpdate.MontantEcarte : 0, [Validators.required, Validators.min(1)]],
      MotifEnvoi: [this.sendECarteToUpdate ? this.sendECarteToUpdate.MotifEnvoi : "", Validators.required],
      EnseigneClientID: [this.sendECarteToUpdate ? this.sendECarteToUpdate.EnseigneClientID : "", Validators.required],
    })

    this.getClient()
}
get EstClientEntreprise () {
  return this.clientFormGroup.get("EstClientEntreprise");
}
get NomEntreprise () {
  return this.clientFormGroup.get("NomEntreprise");
}
get Nom () {
  return this.clientFormGroup.get("Nom");
}
get Prenoms () {
  return this.clientFormGroup.get("Prenoms");
}
get Contact () {
  return this.clientFormGroup.get("Contact");
}
get Adresse () {
  return this.clientFormGroup.get("Adresse");
}
get Description () {
  return this.clientFormGroup.get("Description");
}
get Email () {
  return this.clientFormGroup.get("Email");
}

get MontantEcarte () {
  return this.createUpdateSendECartesForm.get("MontantEcarte");
}

get EnseigneClientID () {
  return this.createUpdateSendECartesForm.get("EnseigneClientID");
}

get MotifEnvoi () {
  return this.createUpdateSendECartesForm.get("MotifEnvoi");
}
telInputObject(event) {
  this.dialCode = event.s.dialCode
}

onCountryChange(event) {
  this.dialCode = event.dialCode
}

onOtpChange(otp) {
  this.otp = otp;
}
sendOTP(){
  let data = {
    "EnvoiID": this.EnvoiID
  }
  this.httpService.execute('enseigneEnvoiEcarte/sendOTP', data).subscribe(res => { 
    if(!res.HasError) {
      this.notification.smallBox({
        title: "Succès !",
        content: res.Message,
        color: "#35a646",
        timeout: 6000,
        icon: "fa fa-check"
    });
    }
    else {
      this.notification.smallBox({
        title: "Oops !",
        content: res.Message,
        color: "rgb(159, 0, 6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    }
  },
    err => {
      this.notification.smallBox({
        title: "Oops !",
        content: err.Message,
        color: "rgb(159, 0, 6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    });
}
verifyOTP() {
  const data = {
    CodeOTP: this.otp,
    "EnvoiID": this.EnvoiID
  };
  this.spinnerLoading = true;
  this.httpService.execute('enseigneEnvoiEcarte/checkOTP', data).subscribe(res => {
    //console.log('check otp response', res);
    if (!res.HasError) {
      this.spinnerLoading = false;
      this.notification.smallBox({
        title: "Succès !",
        content: res.Message,
        color: "#35a646",
        timeout: 6000,
        icon: "fa fa-check"
    });
    this.onClose.next(null);
      this.modalRef.hide()
    } else {
      this.spinnerLoading = false
      this.notification.smallBox({
        title: "Oops !",
        content: res.Message,
        color: "rgb(159, 0, 6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    }
  },
  err => {
    this.spinnerLoading = false;
    this.notification.smallBox({
      title: "Oops !",
      content: err.Message,
      color: "rgb(159, 0, 6)",
      timeout: 6000,
      icon: "fa fa-close"
  });
  });
}

resendOTP() {
  this.notification.smallBox({
    title: "Loading...",
    content: "Vous recevrez un nouveau code OTP dans quelques instants.",
    color: "#139fc2",
    timeout: 6000,
    icon: "fa fa-info-circle"
});
this.sendOTP()
}

getClient(){
  let data = {

    }

    this.httpService.execute("enseigneClient/getByCriteria", data).subscribe(res => {
      if(res.Data && res.Data.length) {
        this.clients = res.Data
      }
      else {
        this.clients = [];
      }
    })
}
    closeModal(){
      this.onClose.next(null);
      this.modalRef.hide()
    }
    resetForm(){
      this.createUpdateSendECartesForm.patchValue({
        MontantEcarte : 0,
        MotifEnvoi : "",
        EntrepriseID: ""
      })
    }

    previous(){
      this.firstStep = true;
    }

    createOrUpdateEnvoi(){
      if(this.firstStep){
        if(this.MontantEcarte.errors){
          this.notification.smallBox({
            title: "Oops !",
            content: "Veuillez renseigner un montant valide",
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        return;
        }
        if(this.MotifEnvoi.errors){
          this.notification.smallBox({
            title: "Oops !",
            content: "Veuillez renseigner le motif",
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        return;
        }

        if(this.EnseigneClientID.errors){
          this.notification.smallBox({
            title: "Oops !",
            content: "Veuillez sélectionner un client",
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        return;
        }
        //Send OTP
        this.createOrUpdate()
      }
      else{
        //Validate OTP and call createOrUpdate()
        this.verifyOTP()
      }
    }

    createOrUpdate(){
      this.spinnerLoading = true
      let envoiID = this.sendECarteToUpdate ? this.sendECarteToUpdate.EnvoiID : (this.EnvoiID ? this.EnvoiID : "")
      let data = {
        ...this.createUpdateSendECartesForm.value,
        EnvoiID : envoiID
      }
      
      this.httpService.execute(envoiID ? "enseigneEnvoiEcarte/update" : "enseigneEnvoiEcarte/create", data).subscribe(res => {
        if (!res.HasError) {
          this.notification.smallBox({
            title: "Succès !",
            content: res.Message,
            color: "#35a646",
            timeout: 6000,
            icon: "fa fa-check"
        });
        this.firstStep = false;
        this.EnvoiID = res.Data.EnvoiID
        this.spinnerLoading = false
        } 
        else {
          this.spinnerLoading = false
          this.notification.smallBox({
            title: "Oops !",
            content: res.Message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        }
      }, err => {
        this.spinnerLoading = false;
        this.notification.smallBox({
          title: "Oops !",
          content: err.Message,
          color: "rgb(159, 0, 6)",
          timeout: 6000,
          icon: "fa fa-close"
      });
      })
    }
    addNewCustomer(){
      console.log("test");
      
      this.addCustomer = true;
      this.clientFormGroup = this.formBuilder.group({
        EstClientEntreprise: [true, [Validators.required]],
        NomEntreprise: [""],
        Nom: ["", Validators.required],
        Prenoms: ["", Validators.required],
        Contact: ["", [Validators.required,Validators.maxLength(10)]],
        Adresse: [""],
        Description: [""],
        Email:   ['',Validators.email]
      })

      this.EstClientEntreprise.valueChanges.subscribe(res => {
        if(res){
          this.NomEntreprise.setValidators(Validators.required);
        }
        else{
          this.NomEntreprise.setValidators(Validators.nullValidator)
        }
        this.NomEntreprise.updateValueAndValidity();
      });

      this.EnseigneClientID.valueChanges.subscribe(res => {
        if(res){
          this.addCustomer = false;
        }
      })
    }

    addClient(){
      this.submitted = true;
      if(this.clientFormGroup.valid){
        this.clientFormGroup.value.Contact = this.dialCode + this.clientFormGroup.value.Contact;

        const data = {
          ...this.clientFormGroup.value,
        };
        console.log("data to send ", data);
        
        this.httpService.execute("enseigneClient/create", data).subscribe(res => {
          if (!res.HasError) {
            this.notification.smallBox({
              title: "Succès !",
              content: res.Message,
              color: "#35a646",
              timeout: 6000,
              icon: "fa fa-check"
          })
          this.EnseigneClientID.setValue(res.Data.EnseigneClientID);
          this.EnseigneClientID.updateValueAndValidity();
          this.getClient();
          this.addCustomer = false;
          this.submitted = false;
          } 
          else {
            this.submitted = false;
            this.notification.smallBox({
              title: "Oops !",
              content: res.Message,
              color: "rgb(159, 0, 6)",
              timeout: 6000,
              icon: "fa fa-close"
          });
          }
        }, err => {
          this.submitted = false;
          this.notification.smallBox({
            title: "Oops !",
            content: err.Message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        })
      }
      else{
        this.submitted = false;
      }
    }
    

}
